module.exports = {
	"Search the video": "동영상 검색",
	"Explore": "탐색",
	"Print": "인쇄",
	"Download": "다운로드",
	"Share": "공유하기",
	"Settings": "환경설정",
	"Language": "언어",
	"Interface Language": "인터페이스 언어",
	"Transcript / Captions Language": "대본/자막 언어",
	"Transcript Language": "대본 언어",
	"Captions Language": "자막 언어",
	"Show Transcript": "대본 보기",
	"Show Captions": "자막 보기",
	"Show Heatmap": "열지도 표시",
	"Show Speakers in Transcript": "대본에 말하는 사람 표시",
	"Keyword": "키워드",
	"Keywords": "키워드",
	"Topic": "주제",
	"Topics": "주제",
	"Speaker": "말하는 사람",
	"Speakers": "말하는 사람",
	"Transcript": "대본",
	"Previous": "이전",
	"Next": "다음",
	"Clear": "지우기",
	"No results found": "결과 없음",
	"try another search or explore": "다시 찾기 또는 탐색",
	"Share Search": "검색결과들로 바로가기",
	"Share Time": "실시간 공유하기",
	"There is no transcript available in the selected language.": "선택하신 언어로는 아직 번역되지 않았습니다",
	"Show {{count}} more": "{{count}} 더 보여주기",
	"Show {{count}} more_plural": "{{count}} 더 보여주기"
};


//////////////////
// WEBPACK FOOTER
// ./locale/ko.json
// module id = ./locale/ko.json
// module chunks = 0 1